import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import MemberCard from "../components/MemberCard";
import api from "../lib/api";
import { Star } from "lucide-react";

export default function Favorites() {
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const { data } = await api.get("/favorites"); setFavs(data.map((m) => ({ ...m, favorited: true }))); }
    catch {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const fav = async (m) => {
    try { await api.post(`/favorite/${m.id}`); setFavs((p) => p.filter((x) => x.id !== m.id)); } catch {}
  };
  const like = async (m) => {
    try { const { data } = await api.post(`/like/${m.id}`); setFavs((p) => p.map((x) => x.id === m.id ? { ...x, liked: data.liked } : x)); } catch {}
  };

  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head font-black text-4xl tracking-tighter mb-1 flex items-center gap-2"><Star className="w-8 h-8 text-[#D4AF37]" fill="#D4AF37" /> Favorites</h1>
        <p className="text-gray-600 font-medium mb-8">Profiles you've saved for later.</p>
        {loading ? <div className="text-center py-20 font-head font-bold uppercase">Loading...</div> :
          favs.length === 0 ? <div className="bg-white nb-border nb-shadow p-10 text-center font-medium">No favorites yet. Tap the star on a profile to save it.</div> : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {favs.map((m) => <MemberCard key={m.id} m={m} onLike={like} onFav={fav} />)}
            </div>
          )}
      </div>
    </div>
  );
}
